import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IComponentOptions, IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import moment from "moment";
import {gettextCatalog} from "angular-gettext";
import {OppgaveRessurs} from "felles/tjenester/ressurser/OppgaveRessurs";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {tilLokalDatoIgnorerTs} from "felles/tjenester/Datoer";

const css = require('./oppgaveStatus.scss');

export function registrerOppgaveStatusKomponent(angular: IModule) {
    angular
        .component('wmOppgaveStatus', oppgaveStatusKomponentDef())
}

export function oppgaveStatusKomponentDef(): IComponentOptions {
    return {
        bindings: {oppgave: "<"},
        controller: OppgaveStatusKontroller.forInjisering(),
        template: require('./oppgaveStatus.html')
    };
}

export class OppgaveStatusKontroller implements IController {
    static forInjisering() {
        return [
            regNavn.gettext.gettextCatalog,
            OppgaveStatusKontroller
        ]
    }

    constructor(private gettextCatalog: gettextCatalog) {
    }

    oppgave: l.OppgaveModell; //satt via bindings
    status: string; //satt via $onChanges
    tooltip: string; //satt via $onChanges
    frist: Date; //satt via $onChanges


    $onChanges(endringer: IOnChangesObject) {
        dersomChangesInneholder(endringer, 'oppgave', dato => this.init());
    }

    // hjelpemetoder

    private init() {
        this.frist = tilLokalDatoIgnorerTs(this.oppgave.frist);
        this.status = OppgaveRessurs.oppgaveStatus(this.oppgave);
        ///tooltip som vises ved mus over oppgave status
        this.tooltip = this.gettextCatalog.getString("Frist {{fristDato}}, utført {{utfoertDato}}", {
            fristDato: this.formaterDato(this.frist),
            utfoertDato: this.formaterDato(this.oppgave.utfoertDato)
        });
    }

    private formaterDato(dato: Date) {
        return dato ? moment(dato).format('L') : '-';
    }

}

